import styled from "@emotion/styled";
import { Flex } from "@mantine/core";
import { Link } from "react-router-dom";

interface IBreadcrumbContainer {
  border?: boolean;
  pb?: number;
}

export const BreadcrumbContainer = styled(Flex)<IBreadcrumbContainer>`
  ${({ border, theme }) =>
    border ? `border-bottom: 1px solid ${theme.colors.main[9]};` : "none"}
  padding-bottom: ${({ pb }: IBreadcrumbContainer) =>
    pb ? `${pb}px` : "15px"};
  display: flex;
`;

export const BreadcrumbLink = styled(Link)`
  user-select: none;
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) =>
    theme.colorScheme === "dark" ? theme.colors.main[6] : theme.colors.main[9]};
  &:hover {
    text-decoration: underline;
  }

  ${({ disabled }: { disabled?: boolean }) =>
    disabled ? `pointer-events: none;` : ""}
`;
